<p-dialog
  [(visible)]="displayModal"
  (onHide)="onDialogHide()"
  [style]="{
    width: '90%',
    height: 'auto',
    minHeight: '85%',
    overflow: 'hidden',
  }"
  appendTo="body"
  header="Task Edit"
  [draggable]="false"
  [resizable]="false">
  <ng-template #header class="edit-header">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center gap-2">
        <h2 class="m-0">
          {{
            taskIdSelected === undefined || taskIdSelected === 0
              ? "Add Task"
              : "Edit Task"
          }}
        </h2>
        <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
      </div>

      <div class="d-flex gap-2" [formGroup]="form">
        <div class="d-flex align-items-center gap-2" formGroupName="parentTask">
          <p class="mb-0">Dateless</p>
          <div>
            <p-toggleswitch
              (onChange)="onDateLessSwitchChangeEvent($event)"
              formControlName="isDateLess" />
          </div>
        </div>

        <div class="d-flex align-items-center gap-2" formGroupName="parentTask">
          <p class="mb-0">Notify Me</p>
          <div><p-toggleswitch formControlName="notification" /></div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="editsummary-popup" [class.task-add-style]="actionType === 'Add'">
    <div class="col-12">
      <form [formGroup]="form" (keydown)="onDialogKeydown($event)">
        <div class="col-12">
          <div class="row gray-bg-rounded bdr-rounded mgr5px">
            <div class="col-lg-8 pl-0 pdr30">
              <div>
                <div class="row g-3">
                  <div class="col-md-6" formGroupName="parentTask">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >Task<span class="madatory-field">*</span></label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        name="pName"
                        formControlName="title"
                        type="text"
                        class="form-control"
                        id="pName" />

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('parentTask.title')?.dirty ||
                            form.get('parentTask.title')?.touched) &&
                          formErrors['title']
                        ">
                        {{ formErrors["title"] }}
                      </span>
                      <span
                        class="error-msg"
                        *ngIf="formErrors['titleWordLimit']">
                        {{ formErrors["titleWordLimit"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-3" formGroupName="subTask">
                    <div class="form-group has-float-label">
                      <label class="form-label"
                        >Due Date<span
                          *ngIf="isDueDateMandatory"
                          class="madatory-field"
                          >*</span
                        >
                      </label>
                      <p-datePicker
                        jniAutoCompleteBlocker
                        appendTo="body"
                        [selectOtherMonths]="true"
                        [style]="{ width: '100%' }"
                        [showButtonBar]="false"
                        formControlName="dueDate"
                        [minDate]="minDate">
                      </p-datePicker>
                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.dueDate')?.dirty ||
                            form.get('subTask.dueDate')?.touched) &&
                          formErrors['dueDate']
                        ">
                        {{ formErrors["dueDate"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-3" formGroupName="subTask">
                    <label class="w-100">Status</label>
                    <p-select
                      [options]="taskStatusList"
                      formControlName="status"
                      optionLabel="name"
                      optionValue="value"
                      class="w-100">
                    </p-select>
                  </div>
                </div>

                <div class="row g-3 mt-1" formGroupName="subTask">
                  <div class="col-md-6">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >Nickname<span
                          *ngIf="!taskIdSelected && formType !== 'Sales Task'"
                          class="madatory-field"
                          >*</span
                        ></label
                      >
                      <p-select
                        *ngIf="!taskIdSelected && formType !== 'Sales Task'"
                        formControlName="nickName"
                        (onChange)="onNickNameChange($event)"
                        [filter]="true"
                        [showClear]="true"
                        [options]="projectLinesList"
                        optionLabel="nickName"
                        appendTo="body"
                        optionValue="nickName">
                      </p-select>

                      <input
                        *ngIf="
                          (taskIdSelected && taskIdSelected > 0) ||
                          formType === 'Sales Task'
                        "
                        pInputText
                        autocomplete="off"
                        jniAutoCompleteBlocker
                        name="nickName"
                        formControlName="nickName"
                        type="text"
                        class="form-control"
                        maxlength="250"
                        id="nickName" />

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.nickName')?.dirty ||
                            form.get('subTask.nickName')?.touched) &&
                          formErrors['nickName']
                        ">
                        {{ formErrors["nickName"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount">ESD</label>

                      <!-- <input
                        pInputText
                        jniAutoCompleteBlocker
                        name="pName"
                        formControlName="esd"
                        type="text"
                        class="form-control"
                        id="pName" /> -->

                      <p-datePicker
                        jniAutoCompleteBlocker
                        appendTo="body"
                        [selectOtherMonths]="true"
                        [style]="{ width: '100%' }"
                        [showButtonBar]="false"
                        formControlName="esd">
                      </p-datePicker>

                      <!-- <span class="error-msg" *ngIf="formErrors['esd']">
                        {{ formErrors["esd"] }}
                      </span> -->
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >PO#<span class="madatory-field">*</span></label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        name="pName"
                        formControlName="purchaseOrderNumber"
                        type="text"
                        class="form-control"
                        id="pName" />

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.purchaseOrderNumber')?.dirty ||
                            form.get('subTask.purchaseOrderNumber')?.touched) &&
                          formErrors['purchaseOrderNumber']
                        ">
                        {{ formErrors["purchaseOrderNumber"] }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row g-3 mt-1" formGroupName="subTask">
                  <div class="col-md-6">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="supplierName"
                        >Supplier<span
                          *ngIf="formType !== 'Sales Task'"
                          class="madatory-field"
                          >*</span
                        ></label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        name="pName"
                        formControlName="supplier"
                        type="text"
                        class="form-control"
                        id="supplierName" />

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.supplier')?.dirty ||
                            form.get('subTask.supplier')?.touched) &&
                          formErrors['supplier']
                        ">
                        {{ formErrors["supplier"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >IHD<span *ngIf="mandotory">*</span></label
                      >
                      <p-datePicker
                        jniAutoCompleteBlocker
                        [inputStyle]="{
                          backgroundColor: ihdColor,
                          opacity: 1,
                        }"
                        [style]="{ width: '100%' }"
                        [showButtonBar]="false"
                        appendTo="body"
                        [selectOtherMonths]="true"
                        formControlName="ihd">
                      </p-datePicker>

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.ihd')?.dirty ||
                            form.get('subTask.ihd')?.touched) &&
                          formErrors['ihd']
                        ">
                        {{ formErrors["ihd"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group has-float-label">
                      <label class="form-label">Remind Me</label>
                      <p-datePicker
                        jniAutoCompleteBlocker
                        [selectOtherMonths]="true"
                        [style]="{ width: '100%' }"
                        [showButtonBar]="false"
                        formControlName="remindMe"
                        [showTime]="true"
                        [hourFormat]="'12'"
                        [minDate]="minDate">
                      </p-datePicker>
                    </div>
                  </div>
                </div>

                <div class="mt-4" formGroupName="parentTask">
                  <p-editor
                    formControlName="description"
                    #emailEditor
                    ngDefaultControl
                    id="email-editor"
                    [style]="{ height: '243px' }"></p-editor>
                </div>
              </div>
            </div>

            <div class="col-lg-4 prcol-0">
              <div>
                <div
                  class="mb-3 row d-flex align-items-end"
                  formGroupName="subTask">
                  <div class="col-lg-6">
                    <div class="form-group has-float-label" *ngIf="showOwner">
                      <label class="form-label">Assigned To</label>
                      <p-select
                        formControlName="assignedTo"
                        [options]="ownerList"
                        [filter]="true"
                        optionLabel="label"
                        optionValue="value"
                        appendTo="body"
                        [showClear]="true">
                      </p-select>
                      <span class="error-msg" *ngIf="formErrors['assignedTo']">
                        {{ formErrors["assignedTo"] }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <p-button
                      label="Update Task"
                      (click)="updateTask()"
                      class="w-100 bg-col-btn"
                      *ngIf="
                        taskIdSelected !== undefined && taskIdSelected !== 0
                      " />
                    <p-button
                      label="Create Task"
                      class="w-100 bg-col-btn"
                      (click)="addTask()"
                      *ngIf="
                        taskIdSelected === undefined || taskIdSelected === 0
                      " />
                  </div>
                </div>

                <div class="mb-3 pb-1" formGroupName="subTask">
                  <!-- <div class="form-group has-float-label">
                    <label class="form-label">Priority</label>
                    <p-select
                      formControlName="priority"
                      [options]="priorityLevelFiltered"
                      optionLabel="title"
                      optionValue="id"
                      appendTo="body"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </div> -->
                  <label>Priority</label>
                  <div class="prority-bar">
                    <p-selectButton
                      [options]="priorityLevelFiltered"
                      formControlName="priority"
                      optionLabel="title"
                      optionValue="id">
                      <ng-template #item let-item>
                        <span class="bullet-btn">
                          <i
                            class="pi pi-circle-fill"
                            [style.color]="item.color"></i>
                        </span>
                        {{ item.title }}
                      </ng-template>
                    </p-selectButton>
                  </div>
                </div>
                <div class="row mt-3" formGroupName="subTask">
                  <div class="col-6">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >Client<span *ngIf="mandotory">*</span></label
                      >

                      <input
                        #clientLookupInput
                        pInputText
                        jniAutoCompleteBlocker
                        autocomplete="off"
                        name="clientLookup"
                        type="text"
                        class="form-control"
                        id="clientLookup"
                        [value]="selectedClientName"
                        formControlName="client"
                        (input)="clientSearch$.next($any($event.target).value)"
                        (keyup)="
                          onClientSearchOpenToggle(
                            clientPopover,
                            $event,
                            clientLookupInput
                          )
                        "
                        (change)="onClientInputChange($event)"
                        (keydown.Tab)="
                          onClientSearchTab($event, clientPopover)
                        " />

                      <p-popover
                        class="order-dropdown add dropDownPosition search-table-position"
                        #clientPopover
                        [appendTo]="'body'"
                        aria-labelledby="clientDropdown">
                        <p-table
                          #dtClient
                          [value]="clientLists"
                          styleClass="p-datatable-customers order-listing"
                          [rowHover]="true"
                          [rows]="10"
                          [showCurrentPageReport]="true"
                          [rowsPerPageOptions]="[10, 25, 50]"
                          [paginator]="false"
                          [filterDelay]="0"
                          [scrollable]="true"
                          scrollHeight="330px">
                          <ng-template pTemplate="header">
                            <tr class="table-head">
                              <th class="name">Name</th>
                              <th class="vaccount">Client Account</th>
                              <th class="street" pSortableColumn="street">
                                Street
                                <p-sortIcon field="street"></p-sortIcon>
                              </th>
                              <th class="city" pSortableColumn="city">
                                City
                                <p-sortIcon field="city"></p-sortIcon>
                              </th>
                              <th class="state" pSortableColumn="state">
                                State
                                <p-sortIcon field="state"></p-sortIcon>
                              </th>
                              <th class="country max-width-7">
                                Last order date
                              </th>
                            </tr>
                            <tr>
                              <th></th>
                              <th></th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="streetFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtClient.filter(
                                        $any($event.target).value,
                                        'street',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="cityFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtClient.filter(
                                        $any($event.target).value,
                                        'city',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="stateFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtClient.filter(
                                        $any($event.target).value,
                                        'state',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th class="max-width-7"></th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-clientItem>
                            <tr
                              class="p-selectable-row mousepointer"
                              (click)="
                                onSalesTaskClientSelection(
                                  clientItem,
                                  clientPopover
                                )
                              ">
                              <td class="name mousepointer">
                                {{ clientItem.organizationNameD365 }}
                              </td>
                              <td class="vaccount mousepointer">
                                {{ clientItem.clientAccount }}
                              </td>
                              <td class="street mousepointer">
                                {{ clientItem.street }}
                              </td>
                              <td class="city mousepointer">
                                {{ clientItem.city }}
                              </td>
                              <td class="state mousepointer">
                                {{ clientItem.state }}
                              </td>
                              <td class="country mousepointer">
                                {{
                                  clientItem.lastOrderDate | date: "yyyy-MM-dd"
                                }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">No client found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-popover>

                      <!-- <input
                        pInputText
                        *ngIf="
                          formType === 'Sales Task' && !isSalesTaskWithProject
                        "
                        name="pClientName"
                        autocomplete="off"
                        formControlName="customerNameWithNoProject"
                        type="text"
                        class="form-control"
                        maxlength="250"
                        id="pClientName" />

                      <input
                        pInputText
                        autocomplete="off"
                        *ngIf="
                          formType !== 'Sales Task' || isSalesTaskWithProject
                        "
                        jniAutoCompleteBlocker
                        name="pName"
                        formControlName="client"
                        type="text"
                        class="form-control"
                        id="pName" /> -->

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.client')?.dirty ||
                            form.get('subTask.client')?.touched) &&
                          formErrors['client']
                        ">
                        {{ formErrors["client"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group has-float-label">
                      <label class="form-label"
                        >Project <span *ngIf="mandotory">*</span
                        ><i
                          *ngIf="projectControl?.value"
                          class="pi pi-external-link ps-1 project-link"
                          (click)="redirectToWorkflowSummary()">
                        </i>
                      </label>

                      <p-select
                        #projectSelect
                        (onChange)="onProjectChange($event)"
                        (onShow)="onProjectDropdownShow()"
                        [filter]="true"
                        [filterValue]="projectFilterValue"
                        (onFilter)="onProjectFilter($event)"
                        [lazy]="true"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="40"
                        (onLazyLoad)="onProjectLazyLoad($event)"
                        appendTo="body"
                        optionValue="projectWorkflowId"
                        optionLabel="projectLabel"
                        [showClear]="clearButton === true"
                        (onClear)="onProjectClear()"
                        [options]="projectLists"
                        [loading]="projectLoading"
                        loadingIcon="pi pi-spinner pi-spin"
                        formControlName="project"
                        placeholder="Select"
                        panelStyleClass="project-dropdown-panel">
                        <ng-template let-item #item>
                          <span class="project-label">
                            {{ item.projectLabel }}
                          </span>
                        </ng-template>
                        <ng-template #loader>
                          <div
                            class="d-flex align-items-center justify-content-center gap-2 p-2">
                            <i class="pi pi-spinner pi-spin"></i>
                            <span>Loading more projects...</span>
                          </div>
                        </ng-template>
                        <ng-template #footer>
                          <div
                            *ngIf="projectLoading"
                            class="d-flex align-items-center justify-content-center gap-2 p-2 border-top">
                            <i class="pi pi-spinner pi-spin"></i>
                            <span>Loading...</span>
                          </div>
                        </ng-template>
                      </p-select>

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.project')?.dirty ||
                            form.get('subTask.project')?.touched) &&
                          formErrors['project']
                        ">
                        {{ formErrors["project"] }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row mt-3" formGroupName="subTask">
                  <div class="col-6">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >Job Name<span *ngIf="mandotory">*</span></label
                      >
                      <div
                        class="clickable-input-wrapper"
                        (click)="
                          openWorkflowSummaryModal(
                            selectedProject?.salesOrderId || '',
                            selectedProject?.projectWorkflowId || 0
                          )
                        ">
                        <input
                          pInputText
                          autocomplete="off"
                          jniAutoCompleteBlocker
                          name="pName"
                          formControlName="jobName"
                          type="text"
                          class="form-control cursor-pointer"
                          maxlength="250"
                          id="pName" />
                      </div>
                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.jobName')?.dirty ||
                            form.get('subTask.jobName')?.touched) &&
                          formErrors['jobName']
                        ">
                        {{ formErrors["jobName"] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >Linked Order<span *ngIf="mandotory">*</span></label
                      >
                      <div
                        *ngIf="
                          formType !== 'Sales Task' || isSalesTaskWithProject
                        "
                        class="clickable-input-wrapper"
                        (click)="
                          openOrderSummaryModal(
                            selectedProject?.salesOrderId || ''
                          )
                        ">
                        <input
                          pInputText
                          autocomplete="off"
                          jniAutoCompleteBlocker
                          name="pName"
                          formControlName="linkedOrder"
                          type="text"
                          class="form-control cursor-pointer"
                          id="pName" />
                      </div>
                      <ng-container
                        *ngIf="
                          formType === 'Sales Task' && isSalesTaskWithoutProject
                        ">
                        <input
                          #orderLookupInput
                          pInputText
                          jniAutoCompleteBlocker
                          name="orderLookup"
                          type="text"
                          class="form-control"
                          id="orderLookup"
                          [value]="selectedOrderNumber"
                          formControlName="linkedOrder"
                          (input)="orderSearch$.next($any($event.target).value)"
                          (keyup)="
                            onOrderSearchOpenToggle(
                              orderPopover,
                              $event,
                              orderLookupInput
                            )
                          "
                          (focus)="
                            onOrderSearchOpenToggle(
                              orderPopover,
                              $event,
                              orderLookupInput
                            )
                          "
                          (click)="
                            onOrderSearchOpenToggle(
                              orderPopover,
                              $event,
                              orderLookupInput
                            )
                          "
                          (change)="onOrderInputChange($event)"
                          (keydown.Tab)="
                            onOrderSearchTab($event, orderPopover)
                          " />

                        <p-popover
                          class="order-dropdown add dropDownPosition search-table-position"
                          #orderPopover
                          [appendTo]="'body'"
                          aria-labelledby="orderDropdown">
                          <p-table
                            #dtOrder
                            [value]="orderLists"
                            styleClass="p-datatable-customers order-listing"
                            [rowHover]="true"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            [paginator]="false"
                            [filterDelay]="0"
                            [scrollable]="true"
                            scrollHeight="330px">
                            <ng-template pTemplate="header">
                              <tr class="table-head">
                                <th class="vaccount">Account #</th>
                                <th class="name">Customer Name</th>
                                <th class="vaccount">Order #</th>
                              </tr>
                              <tr>
                                <th></th>
                                <th>
                                  <div class="d-flex">
                                    <input
                                      pInputText
                                      jniAutoCompleteBlocker
                                      type="text"
                                      name="customerNameFilter"
                                      style="max-width: 200px"
                                      (input)="
                                        dtOrder.filter(
                                          $any($event.target).value,
                                          'customerName',
                                          'contains'
                                        )
                                      "
                                      class="p-column-filter p-inputtext p-component" />
                                  </div>
                                </th>
                                <th></th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-orderItem>
                              <tr
                                class="p-selectable-row mousepointer"
                                (click)="
                                  onSalesTaskOrderSelection(
                                    orderItem,
                                    orderPopover
                                  )
                                ">
                                <td class="vaccount mousepointer">
                                  {{ orderItem.customerAccountD365 }}
                                </td>
                                <td class="name mousepointer">
                                  {{ orderItem.customerName }}
                                </td>
                                <td class="vaccount mousepointer">
                                  {{ orderItem.salesOrderIdD365 }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="3">No orders found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </p-popover>
                      </ng-container>

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('subTask.linkedOrder')?.dirty ||
                            form.get('subTask.linkedOrder')?.touched) &&
                          formErrors['linkedOrder']
                        ">
                        {{ formErrors["linkedOrder"] }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mb-3 mt-3" formGroupName="subTask">
                  <div class="form-group has-float-label">
                    <div class="d-flex gap-3 align-items-center">
                      <div class="col">
                        <label class="form-label" for="Caccount"
                          >Buyer Name</label
                        >

                        <input
                          pInputText
                          *ngIf="
                            formType === 'Sales Task' && showAddBuyer === false
                          "
                          #mydropBuyer
                          autocomplete="off"
                          jniAutoCompleteBlocker
                          name="pName"
                          type="text"
                          class="form-control"
                          formControlName="buyerName"
                          maxlength="250"
                          id="pName" />

                        <input
                          pInputText
                          autocomplete="off"
                          *ngIf="
                            formType !== 'Sales Task' || showAddBuyer === true
                          "
                          #mydropBuyer
                          jniAutoCompleteBlocker
                          name="pName"
                          [value]="selectedBuyer"
                          type="text"
                          class="form-control"
                          id="pName"
                          (focus)="getBuyer($event, bbuyerPopover, mydropBuyer)"
                          (keyup)="getBuyer($event, bbuyerPopover, mydropBuyer)"
                          (keydown.Tab)="
                            getBuyer($event, bbuyerPopover, mydropBuyer)
                          "
                          (click)="
                            getBuyer($event, bbuyerPopover, mydropBuyer)
                          " />
                      </div>
                      <a
                        class="link icon-Add ms-auto mt-3 pt-2"
                        (click)="addContactInformation()"
                        *ngIf="
                          selectedClientName !== '' && showAddBuyer === true
                        ">
                        <i class="pi pi-plus" style="font-size: 0.8rem"></i>
                        Add
                      </a>
                    </div>
                    <p-popover
                      class="order-dropdown add dropDownPosition search-table-position"
                      #bbuyerPopover
                      [appendTo]="'body'"
                      [style]="{ width: 'auto', minWidth: '800px' }"
                      aria-labelledby="dropdownBasic1">
                      <div
                        class="buyer-table-wrapper"
                        (scroll)="onBuyerTableScroll($event)"
                        style="max-height: 400px; overflow-y: auto">
                        <p-table
                          #dt
                          [value]="buyerLists"
                          styleClass="p-datatable-customers order-listing"
                          [rowHover]="true"
                          [rows]="50"
                          [loading]="buyerLoading">
                          <ng-template pTemplate="header">
                            <tr>
                              <th class="name">Buyer</th>
                              <th class="client" pSortableColumn="client">
                                Client
                                <p-sortIcon field="Client"></p-sortIcon>
                              </th>
                              <th class="vaccount">Account</th>
                              <th class="street">Street</th>
                              <th class="city">City</th>
                              <th class="state">State</th>
                              <th class="lastOrderDate">Last order date</th>
                            </tr>
                            <tr>
                              <th>
                                <div class="d-flex">
                                  <input
                                    jniAutoCompleteBlocker
                                    pInputText
                                    type="text"
                                    name="buyer"
                                    id="buyer"
                                    style="max-width: 200px"
                                    (input)="
                                      dt.filter(
                                        $any($event.target).value,
                                        'buyer',
                                        'contains'
                                      )
                                    "
                                    placeholder=""
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    pInputText
                                    type="text"
                                    name="organizationNameD365"
                                    id="organizationNameD365"
                                    style="max-width: 200px"
                                    (input)="
                                      dt.filter(
                                        $any($event.target).value,
                                        'organizationNameD365',
                                        'contains'
                                      )
                                    "
                                    placeholder=""
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th></th>
                            </tr>
                          </ng-template>
                          <ng-template
                            pTemplate="body"
                            let-buyerList
                            let-rowIndex="rowIndex">
                            <tr
                              class="p-selectable-row mousepointer"
                              style="height: 46px"
                              (click)="
                                onBuyerSelection(buyerList, bbuyerPopover)
                              ">
                              <td class="buyer mousepointer">
                                {{ buyerList.buyer }}
                              </td>
                              <td class="client mousepointer">
                                {{ buyerList.organizationNameD365 }}
                              </td>
                              <td class="vaccount mousepointer">
                                {{ buyerList.account }}
                              </td>
                              <td
                                style="width: 200px"
                                class="sname mousepointer">
                                {{ buyerList.street }}
                              </td>
                              <td class="city mousepointer">
                                {{ buyerList.city }}
                              </td>
                              <td
                                style="width: 72px"
                                class="state mousepointer">
                                {{ buyerList.state }}
                              </td>
                              <td
                                style="width: 75px"
                                class="country mousepointer">
                                {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="loadingbody">
                            <tr style="height: 46px">
                              <td><p-skeleton></p-skeleton></td>
                              <td><p-skeleton></p-skeleton></td>
                              <td><p-skeleton></p-skeleton></td>
                              <td><p-skeleton></p-skeleton></td>
                              <td><p-skeleton></p-skeleton></td>
                              <td><p-skeleton></p-skeleton></td>
                              <td><p-skeleton></p-skeleton></td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="20">No buyer found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </p-popover>
                  </div>
                </div>

                <div class="mb-3" formGroupName="subTask">
                  <div class="form-group has-float-label task-dropdown">
                    <label class="form-label">Select Tag</label>
                    <p-multiSelect
                      [options]="tagsList"
                      appendTo="body"
                      formControlName="tag"
                      optionLabel="tagTitle"
                      [filter]="false"
                      class="multiselect-custom"
                      [showHeader]="false"
                      class="w-100">
                      <ng-template let-selectedValues pTemplate="selectedItems">
                        <div
                          class="country-item country-item-value d-flex align-items-center gap-2 border px-2 rounded"
                          *ngFor="let option of selectedValues">
                          <div
                            [style.color]="option.tagColor"
                            class="gap-2 d-flex">
                            <span class="tag-ico"
                              ><i class="pi pi-circle-on"></i
                            ></span>
                            <span>{{ option.tagTitle }}</span>
                            <span class="tag-text-cross"
                              ><i class="pi pi-times"></i
                            ></span>
                          </div>
                        </div>
                        <div
                          *ngIf="!selectedValues || selectedValues.length === 0"
                          class="country-placeholder">
                          Select Tags
                        </div>
                      </ng-template>

                      <ng-template let-tag let-i="index" pTemplate="item">
                        <div
                          class="country-item d-flex justify-content-between w-full w-100">
                          <div [style.color]="tag.tagColor" class="inp-tag">
                            <span class="tag-ico"
                              ><i class="pi pi-circle-on"></i></span
                            >{{ tag.tagTitle }}
                            <span
                              class="tag-text-cross"
                              (click)="deletePTag(tag.tagId)">
                              <i class="pi pi-times"></i>
                            </span>
                          </div>
                          <a
                            href="javascript:;"
                            class="tag-link"
                            *ngIf="tagsList.indexOf(tag) === 0"
                            (click)="
                              showCreateTagDisplay(); $event.stopPropagation()
                            ">
                            Add Tag
                          </a>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="empty">
                        <div
                          class="country-item d-flex justify-content-between w-full w-100">
                          <div>No tags found</div>
                          <div class="d-flex gap-2">
                            <a
                              href="javascript:;"
                              class="tag-link"
                              (click)="showCreateTagDisplay()">
                              Add Tag
                            </a>
                          </div>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </div>
                </div>

                <div class="row" formGroupName="parentTask">
                  <div class="col-lg">
                    <div>
                      <div class="form-group has-float-label">
                        <label class="form-label"
                          >Task Type<span class="madatory-field">*</span></label
                        >
                        <p-select
                          [showClear]="false"
                          [filter]="true"
                          (onChange)="getTaskType($event)"
                          formControlName="taskType"
                          optionLabel="title"
                          optionValue="id"
                          [options]="taskTypes">
                        </p-select>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-auto d-flex gap-3 justify-content-end align-items-end">
                    <div class="d-flex gap-3">
                      <p-button
                        label="Cancel"
                        (click)="closeModal(false)"
                        class="btn-w100px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div class="row">
                <div class="col-lg-8">
                  <div
                    class="gray-bg-rounded bdr-rounded mgr5px"
                    *ngIf="actionType === 'Edit'">
                    <div>
                      <textarea
                        pInputTextarea
                        rows="3"
                        class="w-100 p-3 border"
                        placeholder="Write a comment..."
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="comment">
                      </textarea>

                      <div class="text-end mt-2">
                        <button
                          pButton
                          label="Comment"
                          (click)="sendMessage()"
                          class="btn-w100px"></button>
                      </div>

                      <div class="mt-2">
                        <h5 class="mb-4">
                          Comments
                          <span class="comment-num">{{
                            commentList.length
                          }}</span>
                        </h5>

                        <div class="comment-hgt-scroll">
                          <div
                            *ngFor="let c of commentList"
                            class="mb-3 d-flex gap-2">
                            <p-avatar
                              *ngIf="commentUserPictures.get(c.createdByEmail)"
                              [image]="
                                commentUserPictures.get(c.createdByEmail)
                              "
                              shape="circle"
                              size="large"
                              class="comment-avatar"></p-avatar>
                            <p-avatar
                              *ngIf="!commentUserPictures.get(c.createdByEmail)"
                              [label]="getAcronym(c.createdBy) || ''"
                              [style]="{
                                'background-color': getColor(c.createdBy || ''),
                                color: getTextColor(c.createdBy || ''),
                              }"
                              shape="circle"
                              size="large"
                              class="comment-avatar"></p-avatar>
                            <span class="mt-2 comment-section">
                              <span class="d-flex gap-2 align-items-center">
                                <h6 class="mb-0">{{ c.createdBy }}</h6>
                                <small
                                  class="text-muted ms-2 comment-date"
                                  [pTooltip]="
                                    getFormattedDateForComments(c.createdDate)
                                  "
                                  tooltipPosition="top"
                                  tooltipStyleClass="tasktooltip">
                                  {{ getRelativeTime(c.createdDate) }}
                                </small>
                              </span>
                              <p class="mb-0 mt-1" [innerHTML]="c.comment"></p>
                            </span>
                          </div>
                          <!-- Skeleten-->
                          <div
                            class="mb-3 d-flex gap-2"
                            *ngIf="showCommentsLoader">
                            <span
                              ><p-skeleton
                                shape="circle"
                                size="2.5rem"
                                class="mr-2"
                            /></span>
                            <span class="mt-2 comment-section">
                              <span class="d-flex gap-2 align-items-center">
                                <h6 class="mb-0">
                                  <p-skeleton width="7rem" class="mb-2" />
                                </h6>
                                <small class="text-muted ms-2 comment-date">
                                  <p-skeleton width="4rem" class="mb-2" />
                                </small>
                              </span>
                              <p class="mb-0 mt-1">
                                <p-skeleton width="15rem" class="mb-2" />
                              </p>
                            </span>
                          </div>
                          <!-- Skeleten-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 gray-bg-rounded bdr-rounded">
                  <div>
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"></div>

                    <!-- Display links -->
                    <div
                      class="mb-3 d-flex justify-content-between align-items-center">
                      <h5 class="mb-2">Attachment</h5>
                      <span class="d-flex gap-2">
                        <button
                          pButton
                          (click)="fileInput.click()"
                          label="Attachment"
                          [loading]="isUploadingAttachment"
                          class="btn-w100px"></button>
                        <input
                          pInputText
                          #fileInput
                          label="Attachment"
                          type="file"
                          style="display: none"
                          (change)="uploadTrackingFile($event)" />
                        <button
                          pButton
                          (click)="openTaskFileLinkDailog('Add')"
                          label="Add Links"
                          class="btn-w100px"></button>
                      </span>
                    </div>

                    <!-- Display existing task documents (from API) -->
                    <div class="mb-3 attach-hgt-scroll">
                      <div
                        *ngFor="let document of documentAttachment; index as i"
                        class="mb-2 d-flex justify-content-between align-items-center p-2 border rounded">
                        <a
                          class="m-0"
                          (click)="fileDownload(document.url)"
                          class="text-primary text-truncate flex-grow-1 link">
                          {{ document.name }}
                        </a>

                        <div class="d-flex gap-2">
                          <span
                            class="tag-text-cross"
                            (click)="deleteDocument(i)">
                            <i class="pi pi-times" style="cursor: pointer"></i>
                          </span>
                        </div>
                      </div>

                      <div
                        *ngFor="let document of taskFileLinkList; index as i"
                        class="mb-2 d-flex justify-content-between align-items-center p-2 border rounded">
                        <a
                          target="_blank"
                          class="m-0 link text-primary"
                          [href]="document.fileUrl">
                          {{ document.fileName }}
                        </a>

                        <div class="d-flex gap-2">
                          <span
                            class="tag-text-cross"
                            (click)="editLink(document)">
                            <i class="pi pi-pencil" style="cursor: pointer"></i>
                          </span>
                          <span
                            class="tag-text-cross"
                            (click)="deleteLink(document)">
                            <i class="pi pi-times" style="cursor: pointer"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- <div class="col-lg-12">
    <div class="adduser-container-hgt">
      <div class="row">
        <div class="col-lg-12 field-style">
          <form [formGroup]="form">
            <div class="gray-bg-rounded">
              <div formGroupName="parentTask">
                <div class="row">
                  <div class="col-4 mb-4">
                    <div class="form-group has-float-label">
                      <label class="form-label" for="Caccount"
                        >Task<span class="madatory-field">*</span></label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        name="pName"
                        formControlName="title"
                        type="text"
                        class="form-control"
                        id="pName" />

                      <span
                        class="error-msg"
                        *ngIf="
                          (form.get('parentTask.title')?.dirty ||
                            form.get('parentTask.title')?.touched) &&
                          formErrors['title']
                        ">
                        {{ formErrors["title"] }}
                      </span>
                      <span
                        class="error-msg"
                        *ngIf="formErrors['titleWordLimit']">
                        {{ formErrors["titleWordLimit"] }}
                      </span>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group has-float-label">
                      <label class="form-label"
                        >Task Type<span class="madatory-field">*</span></label
                      >
                      <p-select
                        [showClear]="false"
                        [filter]="true"
                        (onChange)="getTaskType($event)"
                        formControlName="taskType"
                        optionLabel="title"
                        optionValue="id"
                        [options]="taskTypes">
                      </p-select>
                    </div>
                  </div>
                  <div class="col-2 d-flex align-items-center gap-2">
                    <label>Notify Me</label>
                    <p-toggleswitch formControlName="notification" />
                  </div>
                  <div class="col-2 d-flex align-items-center gap-2">
                    <label>Dateless</label>
                    <p-toggleswitch
                      (onChange)="onDateLessSwitchChangeEvent($event)"
                      formControlName="isDateLess" />
                  </div>
                </div>
                <div class="col-lg-12 mb-4 editor-box">
                  <p-editor
                    formControlName="description"
                    #emailEditor
                    ngDefaultControl
                    id="email-editor"
                    [style]="{ height: '200px' }"></p-editor>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 mt-2 mb-2">
                <div
                  class="form-label"
                  [ngStyle]="{ 'text-align': 'right' }"
                  *ngIf="
                    !lockProject &&
                    (taskIdSelected === undefined ||
                      taskIdSelected === 0 ||
                      isSalesTaskSelected)
                  ">
                  <a
                    class="small-link no-decoration"
                    (click)="openAddNewProjectModal()"
                    >Add New Project</a
                  >
                </div>
              </div>
            </div>
            <div class="row" formGroupName="subTask">
              <div class="col-lg-4">
                <div class="gray-bg-rounded">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >Project<span *ngIf="mandotory">*</span></label
                    >
                    <p-select
                      #projectSelect
                      (onChange)="onProjectChange($event)"
                      (onShow)="onProjectDropdownShow()"
                      [filter]="true"
                      [filterValue]="projectFilterValue"
                      (onFilter)="onProjectFilter($event)"
                      [lazy]="true"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="40"
                      (onLazyLoad)="onProjectLazyLoad($event)"
                      appendTo="body"
                      optionValue="projectWorkflowId"
                      optionLabel="projectLabel"
                      [showClear]="clearButton === true"
                      (onClear)="onProjectClear()"
                      [options]="projectLists"
                      [loading]="projectLoading"
                      loadingIcon="pi pi-spinner pi-spin"
                      formControlName="project"
                      placeholder="Select"
                      panelStyleClass="project-dropdown-panel">
                      <ng-template let-item #item>
                        <span class="project-label">
                          {{ item.projectLabel }}
                        </span>
                      </ng-template>
                      <ng-template #loader>
                        <div
                          class="d-flex align-items-center justify-content-center gap-2 p-2">
                          <i class="pi pi-spinner pi-spin"></i>
                          <span>Loading more projects...</span>
                        </div>
                      </ng-template>
                      <ng-template #footer>
                        <div
                          *ngIf="projectLoading"
                          class="d-flex align-items-center justify-content-center gap-2 p-2 border-top">
                          <i class="pi pi-spinner pi-spin"></i>
                          <span>Loading...</span>
                        </div>
                      </ng-template>
                    </p-select>

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.project')?.dirty ||
                          form.get('subTask.project')?.touched) &&
                        formErrors['project']
                      ">
                      {{ formErrors["project"] }}
                    </span>
                  </div>
                  <div class="form-group has-float-label">
                    <label class="form-label" for="Caccount"
                      >Job Name<span *ngIf="mandotory">*</span></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      name="pName"
                      formControlName="jobName"
                      type="text"
                      class="form-control"
                      id="pName" />

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.jobName')?.dirty ||
                          form.get('subTask.jobName')?.touched) &&
                        formErrors['jobName']
                      ">
                      {{ formErrors["jobName"] }}
                    </span>
                  </div>
                  <div
                    class="form-group has-float-label"
                    *ngIf="showOwner">
                    <label class="form-label">Assigned To</label>
                    <p-select
                      formControlName="assignedTo"
                      [options]="ownerList"
                      [filter]="true"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                      [showClear]="true">
                    </p-select>
                    <span class="error-msg" *ngIf="formErrors['assignedTo']">
                      {{ formErrors["assignedTo"] }}
                    </span>
                  </div>
                  <div class="form-group has-float-label">
                    <label class="form-label" for="Caccount"
                      >Nickname<span
                        *ngIf="!taskIdSelected && formType !== 'Sales Task'"
                        class="madatory-field"
                        >*</span
                      ></label
                    >
                    <p-select
                      *ngIf="!taskIdSelected && formType !== 'Sales Task'"
                      formControlName="nickName"
                      (onChange)="onNickNameChange($event)"
                      [filter]="true"
                      [showClear]="true"
                      [options]="projectLinesList"
                      optionLabel="nickName"
                      appendTo="body"
                      optionValue="nickName">
                    </p-select>

                    <input
                      *ngIf="
                        (taskIdSelected && taskIdSelected > 0) ||
                        formType === 'Sales Task'
                      "
                      pInputText
                      jniAutoCompleteBlocker
                      name="nickName"
                      formControlName="nickName"
                      type="text"
                      class="form-control"
                      id="nickName" />

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.nickName')?.dirty ||
                          form.get('subTask.nickName')?.touched) &&
                        formErrors['nickName']
                      ">
                      {{ formErrors["nickName"] }}
                    </span>
                  </div>
                  <div class="form-group has-float-label">
                    <label class="form-label">Priority</label>
                    <p-select
                      formControlName="priority"
                      [options]="priorityLevelFiltered"
                      optionLabel="title"
                      optionValue="id"
                      appendTo="body"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </div>
                </div>

                <div
                  *ngFor="let document of documentAttachment; index as i"
                  style="flex-direction: row"
                  class="gray-bg-rounded mt-3 d-flex col-lg-12 justify-content-between align-items-center">
                  <a class="m-0" (click)="fileDownload(document.url)">
                    {{ document.name }}
                  </a>
                  <a (click)="deleteDocument(i)">
                    <i class="pi pi-times-circle" style="cursor: pointer"></i>
                  </a>
                </div>

                <div
                  *ngFor="let document of taskFileLinkList; index as i"
                  style="flex-direction: row"
                  class="d-flex col-lg-8 justify-content-between align-items-center">
                  <a target="_blank" class="m-0" [href]="document.fileUrl">
                    {{ document.fileName }}
                  </a>

                  <div>
                    <a (click)="editLink(document)" class="m-4">
                      <i class="pi pi-pencil m-0" style="cursor: pointer"></i>
                    </a>
                    <a (click)="deleteLink(document)">
                      <i class="pi pi-times-circle" style="cursor: pointer"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="gray-bg-rounded">
                  <div class="form-group has-float-label">
                    <label class="form-label" for="Caccount"
                      >Client<span *ngIf="mandotory">*</span></label
                    >

                    <input
                      *ngIf="
                        formType !== 'Sales Task' || isSalesTaskWithProject
                      "
                      pInputText
                      jniAutoCompleteBlocker
                      name="pName"
                      formControlName="client"
                      type="text"
                      class="form-control"
                      id="pName" />

                    <ng-container
                      *ngIf="
                        formType === 'Sales Task' && isSalesTaskWithoutProject
                      ">
                      <input
                        #clientLookupInput
                        pInputText
                        jniAutoCompleteBlocker
                        name="clientLookup"
                        type="text"
                        class="form-control"
                        id="clientLookup"
                        [value]="selectedClientName"
                        formControlName="client"
                        (input)="clientSearch$.next($any($event.target).value)"
                        (keyup)="
                          onClientSearchOpenToggle(
                            clientPopover,
                            $event,
                            clientLookupInput
                          )
                        "
                        (change)="onClientInputChange($event)"
                        (keydown.Tab)="
                          onClientSearchTab($event, clientPopover)
                        " />

                      <p-popover
                        class="order-dropdown add dropDownPosition search-table-position"
                        #clientPopover
                        [appendTo]="'body'"
                        aria-labelledby="clientDropdown">
                        <p-table
                          #dtClient
                          [value]="clientLists"
                          styleClass="p-datatable-customers order-listing"
                          [rowHover]="true"
                          [rows]="10"
                          [showCurrentPageReport]="true"
                          [rowsPerPageOptions]="[10, 25, 50]"
                          [paginator]="false"
                          [filterDelay]="0"
                          [scrollable]="true"
                          scrollHeight="330px">
                          <ng-template pTemplate="header">
                            <tr class="table-head">
                              <th class="name">Name</th>
                              <th class="vaccount">Client Account</th>
                              <th class="street" pSortableColumn="street">
                                Street
                                <p-sortIcon field="street"></p-sortIcon>
                              </th>
                              <th class="city" pSortableColumn="city">
                                City
                                <p-sortIcon field="city"></p-sortIcon>
                              </th>
                              <th class="state" pSortableColumn="state">
                                State
                                <p-sortIcon field="state"></p-sortIcon>
                              </th>
                              <th class="country max-width-7">
                                Last order date
                              </th>
                            </tr>
                            <tr>
                              <th></th>
                              <th></th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="streetFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtClient.filter(
                                        $any($event.target).value,
                                        'street',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="cityFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtClient.filter(
                                        $any($event.target).value,
                                        'city',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="stateFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtClient.filter(
                                        $any($event.target).value,
                                        'state',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th class="max-width-7"></th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-clientItem>
                            <tr
                              class="p-selectable-row mousepointer"
                              (click)="
                                onSalesTaskClientSelection(
                                  clientItem,
                                  clientPopover
                                )
                              ">
                              <td class="name mousepointer">
                                {{ clientItem.organizationNameD365 }}
                              </td>
                              <td class="vaccount mousepointer">
                                {{ clientItem.clientAccount }}
                              </td>
                              <td class="street mousepointer">
                                {{ clientItem.street }}
                              </td>
                              <td class="city mousepointer">
                                {{ clientItem.city }}
                              </td>
                              <td class="state mousepointer">
                                {{ clientItem.state }}
                              </td>
                              <td class="country mousepointer">
                                {{
                                  clientItem.lastOrderDate | date: "yyyy-MM-dd"
                                }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">No client found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-popover>
                    </ng-container>

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.client')?.dirty ||
                          form.get('subTask.client')?.touched) &&
                        formErrors['client']
                      ">
                      {{ formErrors["client"] }}
                    </span>
                  </div>
                  <div
                    class="form-group has-float-label"
                    *ngIf="formType !== 'Sales Task'">
                    <label class="form-label" for="supplierName"
                      >Supplier<span class="madatory-field">*</span></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      name="pName"
                      formControlName="supplier"
                      type="text"
                      class="form-control"
                      id="supplierName" />

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.supplier')?.dirty ||
                          form.get('subTask.supplier')?.touched) &&
                        formErrors['supplier']
                      ">
                      {{ formErrors["supplier"] }}
                    </span>
                  </div>
                  <div
                    class="form-group has-float-label"
                    *ngIf="formType !== 'Sales Task'">
                    <label class="form-label" for="Caccount"
                      >PO#<span class="madatory-field">*</span></label
                    >
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      name="pName"
                      formControlName="purchaseOrderNumber"
                      type="text"
                      class="form-control"
                      id="pName" />

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.purchaseOrderNumber')?.dirty ||
                          form.get('subTask.purchaseOrderNumber')?.touched) &&
                        formErrors['purchaseOrderNumber']
                      ">
                      {{ formErrors["purchaseOrderNumber"] }}
                    </span>
                  </div>
                  <div class="form-group has-float-label">
                    <label class="form-label" for="Caccount"
                      >IHD<span *ngIf="mandotory">*</span></label
                    >
                    <p-datePicker
                      jniAutoCompleteBlocker
                      [inputStyle]="{
                        backgroundColor: ihdColor,
                        opacity: 1,
                      }"
                      [style]="{ width: '100%' }"
                      [showButtonBar]="false"
                      appendTo="body"
                      [selectOtherMonths]="true"
                      formControlName="ihd">
                    </p-datePicker>

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.ihd')?.dirty ||
                          form.get('subTask.ihd')?.touched) &&
                        formErrors['ihd']
                      ">
                      {{ formErrors["ihd"] }}
                    </span>
                  </div>
                  <div
                    class="form-group has-float-label"
                    *ngIf="formType !== 'Production Task'">
                    <label class="form-label">Remind Me</label>
                    <p-datePicker
                      jniAutoCompleteBlocker
                      [selectOtherMonths]="true"
                      [style]="{ width: '100%' }"
                      [showButtonBar]="false"
                      formControlName="remindMe"
                      [showTime]="true"
                      [hourFormat]="'12'"
                      [minDate]="minDate">
                    </p-datePicker>
                  </div>

                  <div class="form-group has-float-label task-dropdown">
                    <label class="form-label">Select Tag</label>
                    <p-multiSelect
                      [options]="tagsList"
                      appendTo="body"
                      formControlName="tag"
                      optionLabel="tagTitle"
                      [filter]="false"
                      class="multiselect-custom"
                      [showHeader]="false"
                      class="w-100">
                      <ng-template let-selectedValues pTemplate="selectedItems">
                        <div
                          class="country-item country-item-value"
                          *ngFor="let option of selectedValues">
                          <div [style.color]="option.tagColor">
                            <span class="tag-ico"
                              ><i class="pi pi-tag"></i
                            ></span>
                            {{ option.tagTitle }}
                          </div>
                        </div>
                        <div
                          *ngIf="!selectedValues || selectedValues.length === 0"
                          class="country-placeholder">
                          Select Tags
                        </div>
                      </ng-template>

                      <ng-template let-tag let-i="index" pTemplate="item">
                        <div
                          class="country-item d-flex justify-content-between w-full w-100">
                          <div [style.color]="tag.tagColor" class="inp-tag">
                            <span class="tag-ico"
                              ><i class="pi pi-tag"></i></span
                            >{{ tag.tagTitle }}
                            <span
                              class="tag-cross border rounded-circle"
                              (click)="deletePTag(tag.tagId)">
                              <i class="pi pi-times"></i>
                            </span>
                          </div>
                          <a
                            href="javascript:;"
                            class="tag-link"
                            *ngIf="tagsList.indexOf(tag) === 0"
                            (click)="
                              showCreateTagDisplay(); $event.stopPropagation()
                            ">
                            Add Tag
                          </a>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="empty">
                        <div
                          class="country-item d-flex justify-content-between w-full w-100">
                          <div>No tags found</div>
                          <div class="d-flex gap-2">
                            <a
                              href="javascript:;"
                              class="tag-link"
                              (click)="showCreateTagDisplay()">
                              Add Tag
                            </a>
                          </div>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="gray-bg-rounded">
                  <div class="form-group has-float-label">
                    <label class="form-label" for="Caccount"
                      >Linked Order<span *ngIf="mandotory">*</span></label
                    >

                    <input
                      *ngIf="
                        formType !== 'Sales Task' || isSalesTaskWithProject
                      "
                      pInputText
                      jniAutoCompleteBlocker
                      name="pName"
                      formControlName="linkedOrder"
                      type="text"
                      class="form-control"
                      id="pName" />

                    <ng-container
                      *ngIf="
                        formType === 'Sales Task' && isSalesTaskWithoutProject
                      ">
                      <input
                        #orderLookupInput
                        pInputText
                        jniAutoCompleteBlocker
                        name="orderLookup"
                        type="text"
                        class="form-control"
                        id="orderLookup"
                        [value]="selectedOrderNumber"
                        formControlName="linkedOrder"
                        (input)="orderSearch$.next($any($event.target).value)"
                        (keyup)="
                          onOrderSearchOpenToggle(
                            orderPopover,
                            $event,
                            orderLookupInput
                          )
                        "
                        (focus)="
                          onOrderSearchOpenToggle(
                            orderPopover,
                            $event,
                            orderLookupInput
                          )
                        "
                        (click)="
                          onOrderSearchOpenToggle(
                            orderPopover,
                            $event,
                            orderLookupInput
                          )
                        "
                        (change)="onOrderInputChange($event)"
                        (keydown.Tab)="
                          onOrderSearchTab($event, orderPopover)
                        " />

                      <p-popover
                        class="order-dropdown add dropDownPosition search-table-position"
                        #orderPopover
                        [appendTo]="'body'"
                        aria-labelledby="orderDropdown">
                        <p-table
                          #dtOrder
                          [value]="orderLists"
                          styleClass="p-datatable-customers order-listing"
                          [rowHover]="true"
                          [rows]="10"
                          [showCurrentPageReport]="true"
                          [rowsPerPageOptions]="[10, 25, 50]"
                          [paginator]="false"
                          [filterDelay]="0"
                          [scrollable]="true"
                          scrollHeight="330px">
                          <ng-template pTemplate="header">
                            <tr class="table-head">
                              <th class="vaccount">Account #</th>
                              <th class="name">Customer Name</th>
                              <th class="vaccount">Order #</th>
                            </tr>
                            <tr>
                              <th></th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    pInputText
                                    jniAutoCompleteBlocker
                                    type="text"
                                    name="customerNameFilter"
                                    style="max-width: 200px"
                                    (input)="
                                      dtOrder.filter(
                                        $any($event.target).value,
                                        'customerName',
                                        'contains'
                                      )
                                    "
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th></th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-orderItem>
                            <tr
                              class="p-selectable-row mousepointer"
                              (click)="
                                onSalesTaskOrderSelection(
                                  orderItem,
                                  orderPopover
                                )
                              ">
                              <td class="vaccount mousepointer">
                                {{ orderItem.customerAccountD365 }}
                              </td>
                              <td class="name mousepointer">
                                {{ orderItem.customerName }}
                              </td>
                              <td class="vaccount mousepointer">
                                {{ orderItem.salesOrderIdD365 }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="3">No orders found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-popover>
                    </ng-container>

                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.linkedOrder')?.dirty ||
                          form.get('subTask.linkedOrder')?.touched) &&
                        formErrors['linkedOrder']
                      ">
                      {{ formErrors["linkedOrder"] }}
                    </span>
                  </div>
                  <div class="form-group has-float-label">
                    <div class="drop-bar">
                      <div class="form-group has-float-label">
                        <div class="d-flex gap-1 align-items-center">
                          <div class="col">
                            <label class="form-label" for="Caccount"
                              >Buyer Name</label
                            >
                            <input
                              pInputText
                              #mydropBuyer
                              jniAutoCompleteBlocker
                              name="pName"
                              [value]="selectedBuyer"
                              type="text"
                              class="form-control"
                              id="pName"
                              (focus)="
                                getBuyer($event, bbuyerPopover, mydropBuyer)
                              "
                              (keyup)="
                                getBuyer($event, bbuyerPopover, mydropBuyer)
                              "
                              (keydown.Tab)="
                                getBuyer($event, bbuyerPopover, mydropBuyer)
                              "
                              (click)="
                                getBuyer($event, bbuyerPopover, mydropBuyer)
                              " />
                          </div>
                          <a
                            class="link icon-Add ms-auto mt-3 pt-2"
                            (click)="addContactInformation()"
                            *ngIf="selectedClientName !== ''">
                            +Add
                          </a>
                        </div>
                        <p-popover
                          class="order-dropdown add dropDownPosition search-table-position"
                          #bbuyerPopover
                          [appendTo]="'body'"
                          [style]="{ width: 'auto', minWidth: '800px' }"
                          aria-labelledby="dropdownBasic1">
                          <div
                            class="buyer-table-wrapper"
                            (scroll)="onBuyerTableScroll($event)"
                            style="max-height: 400px; overflow-y: auto">
                            <p-table
                              #dt
                              [value]="buyerLists"
                              styleClass="p-datatable-customers order-listing"
                              [rowHover]="true"
                              [rows]="50"
                              [loading]="buyerLoading">
                              <ng-template pTemplate="header">
                                <tr>
                                  <th class="name">Buyer</th>
                                  <th class="client" pSortableColumn="client">
                                    Client
                                    <p-sortIcon field="Client"></p-sortIcon>
                                  </th>
                                  <th class="vaccount">Account</th>
                                  <th class="street">Street</th>
                                  <th class="city">City</th>
                                  <th class="state">State</th>
                                  <th class="lastOrderDate">Last order date</th>
                                </tr>
                                <tr>
                                  <th>
                                    <div class="d-flex">
                                      <input
                                        jniAutoCompleteBlocker
                                        pInputText
                                        type="text"
                                        name="buyer"
                                        id="buyer"
                                        style="max-width: 200px"
                                        (input)="
                                          dt.filter(
                                            $any($event.target).value,
                                            'buyer',
                                            'contains'
                                          )
                                        "
                                        placeholder=""
                                        class="p-column-filter p-inputtext p-component" />
                                    </div>
                                  </th>
                                  <th>
                                    <div class="d-flex">
                                      <input
                                        pInputText
                                        jniAutoCompleteBlocker
                                        pInputText
                                        type="text"
                                        name="organizationNameD365"
                                        id="organizationNameD365"
                                        style="max-width: 200px"
                                        (input)="
                                          dt.filter(
                                            $any($event.target).value,
                                            'organizationNameD365',
                                            'contains'
                                          )
                                        "
                                        placeholder=""
                                        class="p-column-filter p-inputtext p-component" />
                                    </div>
                                  </th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </ng-template>
                              <ng-template
                                pTemplate="body"
                                let-buyerList
                                let-rowIndex="rowIndex">
                                <tr
                                  class="p-selectable-row mousepointer"
                                  style="height: 46px"
                                  (click)="
                                    onBuyerSelection(buyerList, bbuyerPopover)
                                  ">
                                  <td class="buyer mousepointer">
                                    {{ buyerList.buyer }}
                                  </td>
                                  <td class="client mousepointer">
                                    {{ buyerList.organizationNameD365 }}
                                  </td>
                                  <td class="vaccount mousepointer">
                                    {{ buyerList.account }}
                                  </td>
                                  <td
                                    style="width: 200px"
                                    class="sname mousepointer">
                                    {{ buyerList.street }}
                                  </td>
                                  <td class="city mousepointer">
                                    {{ buyerList.city }}
                                  </td>
                                  <td
                                    style="width: 72px"
                                    class="state mousepointer">
                                    {{ buyerList.state }}
                                  </td>
                                  <td
                                    style="width: 75px"
                                    class="country mousepointer">
                                    {{
                                      buyerList.lastOrder | date: "yyyy-MM-dd"
                                    }}
                                  </td>
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="loadingbody">
                                <tr style="height: 46px">
                                  <td><p-skeleton></p-skeleton></td>
                                  <td><p-skeleton></p-skeleton></td>
                                  <td><p-skeleton></p-skeleton></td>
                                  <td><p-skeleton></p-skeleton></td>
                                  <td><p-skeleton></p-skeleton></td>
                                  <td><p-skeleton></p-skeleton></td>
                                  <td><p-skeleton></p-skeleton></td>
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage">
                                <tr>
                                  <td colspan="20">No buyer found.</td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>
                        </p-popover>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group has-float-label"
                    *ngIf="formType !== 'Sales Task'">
                    <label class="form-label" for="Caccount">ESD</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      name="pName"
                      formControlName="esd"
                      type="text"
                      class="form-control"
                      id="pName" />
                    <span class="error-msg" *ngIf="formErrors['esd']">
                      {{ formErrors["esd"] }}
                    </span>
                  </div>
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >Due Date<span
                        *ngIf="isDueDateMandatory"
                        class="madatory-field"
                        >*</span
                      >
                    </label>
                    <p-datePicker
                      jniAutoCompleteBlocker
                      appendTo="body"
                      [selectOtherMonths]="true"
                      [style]="{ width: '100%' }"
                      [showButtonBar]="false"
                      formControlName="dueDate"
                      [minDate]="minDate">
                    </p-datePicker>
                    <span
                      class="error-msg"
                      *ngIf="
                        (form.get('subTask.dueDate')?.dirty ||
                          form.get('subTask.dueDate')?.touched) &&
                        formErrors['dueDate']
                      ">
                      {{ formErrors["dueDate"] }}
                    </span>
                  </div>
                  <div
                    class="form-group has-float-label"
                    *ngIf="formType === 'Production Task'">
                    <label class="form-label">Remind Me</label>
                    <p-datePicker
                      jniAutoCompleteBlocker
                      [selectOtherMonths]="true"
                      [style]="{ width: '100%' }"
                      [showButtonBar]="false"
                      formControlName="remindMe"
                      [showTime]="true"
                      [hourFormat]="'12'">
                    </p-datePicker>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between bottom-btn-sticky">
      <div class="d-flex gap-3">
        <p-button
          (click)="fileInput.click()"
          label="Attachment"
          [loading]="isUploadingAttachment" />
        <input
          pInputText
          #fileInput
          label="Attachment"
          type="file"
          style="display: none"
          (change)="uploadTrackingFile($event)" />

        <p-button (click)="openTaskFileLinkDailog('Add')" label="Add Link" />
      </div>

      <div class="d-flex gap-3 justify-content-end">
        <p-button label="Cancel" (click)="closeModal(false)" />
        <p-button
          label="Update Task"
          (click)="updateTask()"
          *ngIf="taskIdSelected !== undefined && taskIdSelected !== 0" />
        <p-button
          label="Create Task"
          (click)="addTask()"
          *ngIf="taskIdSelected === undefined || taskIdSelected === 0" />
      </div>
    </div>
  </div> -->
</p-dialog>

<p-dialog
  [(visible)]="displayCreateTagModal"
  [style]="{ width: '450px', height: 'auto' }"
  appendTo="body"
  header="Create Tag">
  <div [formGroup]="tagForm" class="p-fluid">
    <div class="mb-4">
      <label class="form-label mb-2" for="tagTitle"
        >Tag Title<span class="madatory-field">*</span></label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="tagTitle"
        formControlName="tagTitle" />
    </div>
    <div class="mb-4">
      <label class="form-label mb-2">Pick Color</label>
      <div class="d-flex gap-3 align-items-start">
        <p-colorPicker
          formControlName="tagColor"
          [inline]="true"
          (onChange)="onColorChange($event)"></p-colorPicker>
        <div class="color-display" [style.backgroundColor]="color1"></div>
      </div>
    </div>
    <div class="d-flex gap-3 justify-content-end mt-4">
      <p-button label="Cancel" (click)="displayCreateTagModal = false" />
      <p-button label="Create Tag" (click)="addTag()" />
    </div>
  </div>
</p-dialog>
<jni-confirm-dialog
  [dialogMessage]="deleteTagMessage"
  dialogHeading="Delete Confirmation"
  *ngIf="deleteTagVisible"
  (confirmDialogStatus)="confirmDeletePTag($event)">
</jni-confirm-dialog>
<jni-confirm-dialog
  [dialogMessage]="changeAlertMessage"
  dialogHeading="Are you sure?"
  *ngIf="changeAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmAlertBuyer($event)">
</jni-confirm-dialog>
<jni-confirm-change
  *ngIf="changeBuyerVisible"
  (confirmDialogStatus)="confirmChangeBuyer($event)">
</jni-confirm-change>

<p-dialog
  header="{{ taskFileLinkModalHeader }}"
  [position]="'center'"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showAddTaskFileLinkModal"
  [style]="{
    width: '300px',
    height: '360px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-4">
      <label class="form-label" for="taskFileLink">File Link</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="taskFileLink"
        name="taskFileLink"
        [(ngModel)]="taskFileLink" />
    </div>
    <div class="form-group has-float-label mt-2 mb-4">
      <label class="form-label" for="projectLinkName">Link Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="taskLinkName"
        name="taskLinkName"
        [(ngModel)]="taskLinkName" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
      <div class="row">
        <div class="col">
          <div class="d-flex mb-2 gap-2">
            <p-button label="Cancel" (click)="closeLinkFileLinkDailog()" />

            <p-button
              label="Update"
              (click)="editTaskFileLink()"
              *ngIf="taskFileLinkMode === 'Edit'" />

            <p-button
              label="Save"
              (click)="addTaskFileLink()"
              *ngIf="taskFileLinkMode === 'Add'" />
          </div>
        </div>
      </div>
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeLinkFileLinkDailog()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        (click)="editTaskFileLink()"
        *ngIf="taskFileLinkMode === 'Edit'">
        Update
      </button> -->
      <!-- <button
        class="btn btn-primary"
        type="submit"
        (click)="addTaskFileLink()"
        *ngIf="taskFileLinkMode === 'Add'">
        Save
      </button> -->
    </div>
  </div>
</p-dialog>
<p-dialog
  header="Confirmation"
  [position]="'center'"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showProjectChangeConfirmationModal">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="p-field p-mb-2 field-wrap">
      <label
        class="text-bold matchMode form-group has-float-label mb-1"
        style="font-size: 15px"
        >{{ showProjectChangeConfirmationModalHeading }}</label
      >
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
      <button
        class="btn btn-secondary me-5"
        type="button"
        (click)="projectChangeNoBtnClicked()">
        No
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        (click)="projectChangeYesBtnClicked()">
        Yes
      </button>
    </div>
  </div>
</p-dialog>

<!-- Sales Task Project Fields Override Confirmation Modal -->
<p-dialog
  header="Confirmation"
  [position]="'center'"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [closable]="false"
  [(visible)]="showSalesTaskProjectFieldsOverrideModal">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="p-field p-mb-2 field-wrap">
      <label
        class="text-bold form-group has-float-label mb-1"
        style="font-size: 15px; text-transform: none"
        >Client, job name, buyer, IHD values will be filled from selected
        project. Continue?</label
      >
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-2">
      <button
        class="btn btn-secondary"
        type="button"
        (click)="salesTaskProjectFieldsOverrideNo()">
        No
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        (click)="salesTaskProjectFieldsOverrideYes()">
        Yes
      </button>
    </div>
  </div>
</p-dialog>
